import { ApiService } from "../model/Api.model";
import { AxiosInstance } from "axios";
import ITradeApprovalPhaseLog from "../interface/trade/ITradeApprovalPhaseLog";

enum TradeApprovalPhaseLogServiceEnum {
  getByTradeId = "/get-by-trade-id?tradeId="
}
export default class TradeApprovalPhaseLogService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/approval-phase-log");
  }

  public getByTradeId = async (idTrade: number): Promise<ITradeApprovalPhaseLog[]> => await this.GET(TradeApprovalPhaseLogServiceEnum.getByTradeId + idTrade);
}
